import { Chip } from '@mui/material';

const BetaLabel = () => (
  <Chip
    variant="filled"
    color="secondary"
    label="BETA"
    sx={{ maxWidth: 'min-content' }}
  />
);

export default BetaLabel;
